import { ReactNode } from "react";
import { useReportLoading } from "../../../contexts/ReportLoadingContext";
import { flattenSelection, useFilterContextV2 } from "../../../contexts/FilterContextV2";
export function ReportRoute({ children }: { children: ReactNode }) {
  const { loading, error } = useReportLoading();
  const { selectedFarms, selectedAreas } = useFilterContextV2();
  const empty = !flattenSelection(selectedFarms).length || !flattenSelection(selectedAreas).length;
  return <div className={`report-route${loading || error ? " report-loading" : ""}${empty ? " report-empty-selection" : ""}`} aria-busy={loading}>{children}</div>;
}
